<template>
  <div class="home-dashboard">
    <section class="dashboard-card"><h2>Tu carta digital</h2><p>Comparte el enlace o el código QR con tus clientes.</p><a class="public-menu-link" :href="url" target="_blank" rel="noopener">{{ url }}</a><div class="dashboard-qr"><qrcode-vue v-if="url" :value="url" :size="size" level="H" /></div><a :href="url" target="_blank" rel="noopener" class="dashboard-link">Ver la carta <i class="el-icon-top-right" /></a></section>
    <section class="dashboard-card"><h2>Publicación</h2><p>Elige qué apartados están disponibles para tus clientes.</p><div class="publication-option"><div><strong>Carta</strong><p>Platos y grupos de tu carta habitual.</p></div><el-switch v-model="enableCarta" aria-label="Mostrar la carta" @change="setData" /></div><div class="publication-option"><div><strong>Menús</strong><p>Familias y selecciones de platos.</p></div><el-switch v-model="enableMenu" aria-label="Mostrar los menús" @change="changeStatus" /></div><router-link to="/Restaurante" class="dashboard-link">Editar información general <i class="el-icon-arrow-right" /></router-link></section>
    <statistics-overview />
    <backup-overview />
  </div>
</template>
<script>
import * as api from "../api/request.js";
import storage from "../api/storage.js";
import QrcodeVue from 'qrcode.vue';
import StatisticsOverview from '../components/StatisticsOverview.vue';
import BackupOverview from '../components/BackupOverview.vue';
export default {
  data()
  {
    return {
      size: 200,
      url: "",
      enableCarta: null,
      enableMenu: null,
      data: [],
    }
  },
   mounted() {
    this.authenticated = storage.loadAuthenticated();
    if (this.authenticated === false || this.authenticated === null) {
      this.$router.replace({ name: "login" });
    } else {
      this.loadData();
    }
  },
  components: {
    QrcodeVue,
    StatisticsOverview,
    BackupOverview,
  },
  methods:
  {
    loadData: async function()
    {
      let dataEnableCarta = await api.getDataBusiness();
      this.enableCarta = dataEnableCarta.enableCarta;
      this.enableMenu = dataEnableCarta.enableMenu;
      this.url = process.env.VUE_APP_LOCAL_CARTA_URL
        ? process.env.VUE_APP_LOCAL_CARTA_URL + "/?restaurante=" + encodeURIComponent(dataEnableCarta.url)
        : 'https://' + dataEnableCarta.url + '/';
    },
    setData: async function () {
      await api.setDataBusiness({enableCarta: this.enableCarta, enableMenu: this.enableMenu});
    },
    changeStatus: async function () {
        this.setData();
    },
  }
};
</script>
<style scoped>
.home-dashboard { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; }
.dashboard-card { background: white; border: 1px solid #dce4e3; border-radius: 14px; padding: 28px; }
.dashboard-card h2 { font-size: 21px; margin: 0 0 10px; }
.dashboard-card p { color: #687780; line-height: 1.6; font-size: 14px; }
.public-menu-link { display: block; overflow-wrap: anywhere; font-size: 14px; }
.dashboard-qr { margin: 24px 0; }
.dashboard-link { display: inline-flex; align-items: center; gap: 10px; text-decoration: none; font-size: 14px; font-weight: 700; min-height: 44px; }
.publication-option { display: flex; align-items: center; justify-content: space-between; gap: 16px; border-bottom: 1px solid #edf1ef; padding: 20px 0; }
.publication-option p { margin: 4px 0 0; }
@media(max-width:760px) { .home-dashboard { grid-template-columns: 1fr; } .dashboard-card { padding: 20px; } }
</style>
